// Plan and usage (A12U11, D183): owners and admins (plan.read); everyone else gets NoAccess inside the shell.
import { ids } from '@orca/api-client/testIds'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { planQuery } from '../../../../features/members/queries'
import { OrgSection } from '../../../../features/organization/OrgSection'
import { PlanPage, usePlanSubtitle } from '../../../../features/organization/PlanPage'
import { holds } from '../../../../features/organization/sections'
import { orgQuery } from '../../../../features/settings/queries'
import { accessQuery } from '../../../../shared/access/access'
import { Part } from '../../../../shared/shell/StatePart'

export const Route = createFileRoute('/o/$orgSlug/organization/plan')({
  staticData: { screenId: 'OrgPlanScreen', access: 'plan.read', ownHeader: true },
  loader: async ({ context: { queryClient, membership } }) => {
    const access = await queryClient.ensureQueryData(accessQuery(membership.orgId)).catch(() => null)
    await queryClient.ensureQueryData(orgQuery(membership.orgId))
    if (holds(access, 'plan.read')) await queryClient.ensureQueryData(planQuery(membership.orgId))
    return { orgId: membership.orgId }
  },
  component: OrgPlanScreen,
})

function OrgPlanScreen() {
  const { t } = useTranslation()
  const { orgId } = Route.useLoaderData()
  const subtitle = usePlanSubtitle(orgId)
  const title = useQuery(orgQuery(orgId)).data?.plan.name
  return (
    <OrgSection
      orgId={orgId}
      section="plan"
      root={ids.orgPlan.root}
      title={title ? t('organization.plan.title', { plan: title }) : t('organization.section.plan')}
      subtitle={subtitle}
    >
      <Part>
        <PlanPage orgId={orgId} />
      </Part>
    </OrgSection>
  )
}
